import { initializeAppCheck, ReCaptchaEnterpriseProvider, getToken } from 'firebase/app-check';
import { httpsCallable } from 'firebase/functions';
import { app, projectFunctions } from './firebase';

let intakeAppCheck;
export async function submitAttorneyApplication(data) {
  const siteKey = process.env.VUE_APP_INTAKE_RECAPTCHA_SITE_KEY;
  if (!siteKey) throw new Error('Applications are not available yet. Please try again later.');
  if (!intakeAppCheck) intakeAppCheck = initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider(siteKey), isTokenAutoRefreshEnabled: true });
  await getToken(intakeAppCheck);
  const result = await httpsCallable(projectFunctions, 'submitAttorneyApplication')(data);
  if (!result.data?.applicationId || result.data.status !== 'submitted') throw new Error('Unable to confirm your submission. Please try again.');
  return result.data;
}
